import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExhibitorOverviewPage } from '../features/exhibitor/overview/exhibitor-overview.page';
import { NavigationPage } from '../features/navigation/page/navigation.page';

const ROUTES: Routes = [
    {path: '', component: ExhibitorOverviewPage },
    {path: 'navigation', component: NavigationPage},
    {path: 'exhibitor', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(ROUTES)],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
